export enum GADimension {
    TicketInsurance = 'dimension1',
    PartnerId = 'dimension2',
    SelectedDeliveryName = 'dimension3',
    SelectedPaymentName = 'dimension4',
    DisplayMode = 'dimension5',
    NotificationPermissionState = 'dimension6',
    PromotorId = 'dimension7',
    AddToCartSelectionMethod = 'dimension8',
    EventId = 'dimension9',
    EventName = 'dimension10',
    CustomerType = 'dimension11',
    Vouchers = 'dimension12',
}
